import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/tooltip.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-4a12ecfb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tableCornerRadius bg-white" }
const _hoisted_2 = { class: "table-container" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["onUpdate:modelValue"]
const _hoisted_6 = ["value"]
const _hoisted_7 = ["value"]
const _hoisted_8 = ["onUpdate:modelValue"]
const _hoisted_9 = ["value"]
const _hoisted_10 = ["value"]
const _hoisted_11 = { key: 2 }
const _hoisted_12 = ["onUpdate:modelValue"]
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "cursor-pointer empty rowHeight" }
const _hoisted_15 = ["colspan"]
const _hoisted_16 = { class: "flex items-center justify-center w-full h-16 skeleton" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "cursor-pointer empty rowHeight" }
const _hoisted_19 = ["colspan"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-normal" }, "No Records Found")
], -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = {
  key: 2,
  class: "empty"
}
const _hoisted_23 = ["onMouseout", "onClick"]
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = ["onMousemove"]
const _hoisted_27 = ["onMousemove"]
const _hoisted_28 = {
  key: 2,
  class: "flex justify-center items-center bg-white opacity-0 lasttooltip absolute z-50 group-hover:opacity-100 border pointer-events-none"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "absolute text-black bottom-full left-0 -mb-1 h-3.5 w-3"
}, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-black text-center text-xs" }, null, -1))
const _hoisted_31 = {
  key: 3,
  class: "flex justify-center items-center bg-white opacity-0 lasttooltip absolute z-50 group-hover:opacity-100 border pointer-events-none cursor-pointer"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "absolute text-black bottom-full left-0 -mb-1 h-3.5 w-3"
}, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-black text-center text-xs" }, null, -1))
const _hoisted_34 = {
  key: 2,
  class: "table-ellipsis"
}
const _hoisted_35 = ["onMousemove"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dots_loader = _resolveComponent("dots-loader")!
  const _component_pagination = _resolveComponent("pagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("table", null, [
          _createElementVNode("thead", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnNames, (column) => {
              return (_openBlock(), _createElementBlock("th", {
                scope: "col",
                class: _normalizeClass([_ctx.getHeaderProperties('width',column), "bg-white cursor-pointer capitalize"]),
                key: column,
                onClick: ($event: any) => (_ctx.sort(column))
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["flex", _ctx.getHeaderAlignment(column)])
                }, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.getHeaderProperties('name',column)), 1),
                  _createElementVNode("div", {
                    class: _normalizeClass(["sort cursor-pointer", _ctx.className == column ? _ctx.classSort : 'opacity-50'])
                  }, null, 2)
                ], 2)
              ], 10, _hoisted_3))
            }), 128)),
            (_ctx.visibility)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnNames, (column, index) => {
                    return (_openBlock(), _createElementBlock("td", {
                      class: _normalizeClass(["bg-white", column == 'status'||column=='isActive' ? 'flex items-center justify-center' : '']),
                      key: index
                    }, [
                      (column == 'criticality')
                        ? _withDirectives((_openBlock(), _createElementBlock("select", {
                            key: 0,
                            class: _normalizeClass(["widthForSelect filter-font-size", _ctx.filters[column] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect']),
                            "onUpdate:modelValue": ($event: any) => ((_ctx.filters[column]) = $event)
                          }, [
                            _createElementVNode("option", {
                              value: _ctx.filters.column,
                              selected: "",
                              hidden: "",
                              disabled: ""
                            }, "Select", 8, _hoisted_6),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.criticalityoptions, (option) => {
                              return (_openBlock(), _createElementBlock("option", {
                                class: "optionColors",
                                key: option.id,
                                value: option.id
                              }, _toDisplayString(option.value), 9, _hoisted_7))
                            }), 128))
                          ], 10, _hoisted_5)), [
                            [_vModelSelect, _ctx.filters[column]]
                          ])
                        : _createCommentVNode("", true),
                      (column=='isActive')
                        ? _withDirectives((_openBlock(), _createElementBlock("select", {
                            key: 1,
                            class: _normalizeClass([_ctx.filters[column] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect', "widthForSelect"]),
                            "onUpdate:modelValue": ($event: any) => ((_ctx.filters[column]) = $event)
                          }, [
                            _createElementVNode("option", {
                              value: _ctx.select,
                              selected: "",
                              hidden: "",
                              disabled: ""
                            }, "Select", 8, _hoisted_9),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeValues, (pair) => {
                              return (_openBlock(), _createElementBlock("option", {
                                class: "optionColors",
                                key: pair,
                                value: pair.id
                              }, _toDisplayString(pair.value), 9, _hoisted_10))
                            }), 128))
                          ], 10, _hoisted_8)), [
                            [_vModelSelect, _ctx.filters[column]]
                          ])
                        : (column =='criticality')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11))
                          : _withDirectives((_openBlock(), _createElementBlock("input", {
                              key: 3,
                              type: "text",
                              placeholder: "Search",
                              class: "searchForInputBoxStyling",
                              "onUpdate:modelValue": ($event: any) => ((_ctx.filters[column]) = $event)
                            }, null, 8, _hoisted_12)), [
                              [_vModelText, _ctx.filters[column]]
                            ])
                    ], 2))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.loadData == true)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_13, [
                _createElementVNode("tr", _hoisted_14, [
                  _createElementVNode("td", {
                    class: "relative h-5",
                    colspan: _ctx.columnNames.size
                  }, [
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_dots_loader)
                    ])
                  ], 8, _hoisted_15)
                ])
              ]))
            : (_ctx.sortedData.length==0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_17, [
                  _createElementVNode("tr", _hoisted_18, [
                    _createElementVNode("td", {
                      class: "relative h-10",
                      colspan: _ctx.columnNames.size
                    }, _hoisted_21, 8, _hoisted_19)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_22, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedData, (row, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: row,
                      class: "cursor-pointer rowHeight"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnNames, (column, indexx) => {
                        return (_openBlock(), _createElementBlock("td", {
                          key: indexx,
                          onMouseout: ($event: any) => (_ctx.doFalse(column)),
                          onClick: ($event: any) => (_ctx.actionOnClickingTableRow(column,row,index)),
                          class: "cursor-pointer relative"
                        }, [
                          _createElementVNode("div", null, [
                            (column == 'criticality')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 px-2.5 regular", _ctx.colorCriticalityBg(row[column])])
                                  }, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(_ctx.colorCriticalityText(row[column]))
                                    }, _toDisplayString(_ctx.criticalityoptions.find((l) => {
                                                    return l.id == row[column];
                                                }).value), 3)
                                  ], 2)
                                ]))
                              : (column == 'isActive')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                    (row[column] == true)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          class: "rounded-full w-5 h-5 bg-active mx-auto",
                                          onMousemove: ($event: any) => (_ctx.toolTip(column, $event, index, row, 'circleButton'))
                                        }, null, 40, _hoisted_26))
                                      : (_openBlock(), _createElementBlock("div", {
                                          key: 1,
                                          class: "rounded-full w-5 h-5 bg-error mx-auto",
                                          onMousemove: ($event: any) => (_ctx.toolTip(column, $event, index, row, 'circleButton'))
                                        }, null, 40, _hoisted_27)),
                                    (row[column] == true && _ctx.pop == true)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                          _hoisted_29,
                                          _hoisted_30,
                                          _createTextVNode(" Active ")
                                        ]))
                                      : _createCommentVNode("", true),
                                    (row[column] == false && _ctx.pop == true)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                          _hoisted_32,
                                          _hoisted_33,
                                          _createTextVNode(" Inactive ")
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                    _createElementVNode("p", {
                                      class: "fullText",
                                      onMousemove: ($event: any) => (_ctx.toolTip(column, $event, index, row, 'text'))
                                    }, _toDisplayString(row[column]), 41, _hoisted_35)
                                  ]))
                          ])
                        ], 40, _hoisted_23))
                      }), 128))
                    ]))
                  }), 128))
                ]))
        ])
      ]),
      _createVNode(_component_pagination, {
        dynamicPagination: _ctx.dynamicPagination,
        onCurrentPageUpdate: _ctx.paginationUpdations,
        sortedData: _ctx.sortedData
      }, null, 8, ["dynamicPagination", "onCurrentPageUpdate", "sortedData"])
    ])
  ]))
}